
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import OKRCreationForm from "@/components/okrs/OKRCreationForm";
import { useQuery } from "@tanstack/react-query";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const CreateOKRPage = () => {
  const navigate = useNavigate();

  const { data: existingOKRs } = useQuery({
    queryKey: ["okrs"],
    queryFn: async () => {
      // TODO: Replace with actual API call
      return [];
    },
  });

  const isFirstTimeUser = !existingOKRs || existingOKRs.length === 0;

  return (
    <div className="container mx-auto px-4 py-4 md:py-8 animate-fade-in">
      <div className="flex items-start gap-3 mb-4 md:mb-6">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => navigate("/artifacts/okrs")}
          className="flex-shrink-0"
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-xl md:text-2xl lg:text-4xl font-bold mb-1 md:mb-2">
            {isFirstTimeUser ? "Set Your First OKR" : "Create New OKR"}
          </h1>
          <p className="text-text-secondary text-sm md:text-base lg:text-lg">
            {isFirstTimeUser
              ? "Start your journey of measurable career growth"
              : "Add another milestone to your career journey"}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        <div className="lg:col-span-8">
          <Card className="p-4 md:p-6">
            <OKRCreationForm onSuccess={() => navigate("/artifacts/okrs")} />
          </Card>
        </div>

        <div className="lg:col-span-4">
          <Card className="p-4 md:p-6 lg:sticky lg:top-20">
            <h2 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">Quick Tips</h2>
            <ul className="space-y-2 md:space-y-3 text-sm md:text-base text-text-secondary">
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span> 
                <span>Make objectives ambitious but achievable</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span> 
                <span>Keep key results measurable</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span> 
                <span>Aim for 2-3 key results per objective</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span> 
                <span>Think quarterly timeframe</span>
              </li>
            </ul>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CreateOKRPage;
